/* eslint-disable camelcase */
/* @flow strict */

import * as React from 'react';
import SimpleInput from '/client/src/components/forms/simpleInput';
import SimpleCheckbox from '/client/src/components/forms/checkbox';
import _ from 'lodash';

import './PhotoStyles.scss';

type PropsType = {
  eventDetail: {
    splash_page: {
      theme: string
    }
  },
  onHandleChange: () => void,
  title: string,
  editablePart?: any
};

class SectionHeader extends React.Component<PropsType> {
  props: PropsType;

  constructor(props: PropsType) {
    super(props);

    this.state = {
      link_label: props.title,
      addToNav: _.get(props, 'editablePart.addToNav', true),
      background_color: _.get(props, 'editablePart.background_color', 'Light')
    };
  }

  setSectionTitle = (value: string) => {
    this.setState({
      link_label: value
    });

    this.props.onHandleChange({ link_label: value });
  };

  handleChangeCheckbox = () => {
    const addToNav = !this.state.addToNav;

    this.setState({ addToNav });
    this.props.onHandleChange({ addToNav });
  };
  handleChangeMapColor = (background_color: string) => {
    this.setState({ background_color });
    this.props.onHandleChange({ background_color });
  }
  render(): React.Element<typeof React.Fragment> {
    const {
      link_label,
      addToNav,
      background_color
    } = this.state;

    return (
      <div className='sectionHeader'>
        <div className="row">
          <div className="col-xs-3">
            <label className="control-label">Section Title</label>
          </div>
          <div className="col-xs-5">
            <SimpleInput
              name='photos'
              id='photos'
              value={link_label}
              onChange={(e: any) => {
                this.setSectionTitle(e.target.value);
              }}
            />
          </div>
          <div className="col-xs-4" style={{ whiteSpace: 'nowrap' }}>
            <SimpleCheckbox
              label='Add a navigation link to this section'
              checked={addToNav}
              // eslint-disable-next-line
              callBack={this.handleChangeCheckbox}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-3">
            <label className="control-label">Background Color</label>
          </div>

          <div className="col-xs-9">
            <div className="dropdown part-color-dropdown Light">
              <button
                type="button"
                className="btn btn-default dropdown-toggle"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                <span className={`part-color ${background_color === 'Light' ? 'Light' : 'darkTheme-Dark'}`} />
                <span className="icon icon-angle-down" />
              </button>

              <ul className="dropdown-menu" role="menu">
                    <li onClick={() => this.handleChangeMapColor('Light')}>
                      <a href="#" className={background_color === 'Light' ? 'bc_selected' : ''}>
                        <span>White</span>
                      </a>
                    </li>
                    <li onClick={() => this.handleChangeMapColor('Dark')}>
                      <a href="#" className={background_color === 'Dark' ? 'bc_selected' : ''}>
                        <span>Black</span>
                      </a>
                    </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SectionHeader;
